import {Component, OnInit} from '@angular/core';
import {AuthService, ParserService, BlockAbstractComponent, PageService} from '@gallaghercp/core-frontend';
import {Observable} from 'rxjs';

@Component({
    standalone: false,
    selector: 'core-block-sitemap',
    templateUrl: './block-sitemap.component.html',
})

export class BlockSitemapComponent extends BlockAbstractComponent implements OnInit {
    loading?: boolean;
    pages$?: Observable<any>;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService
    ) {
        super(
            parser,
            auth,
            pages,
        );
    }

    override ngOnInit() {
        super.ngOnInit();
        this.loading = true;
        this.pages$ = this.pages.getAll();
    }

}
